import React, { useState } from "react";
import "../Styles/PanelType.css";
import MainFrame from "./ConfigurationFrames/MainFrame";
import LoginPasswordFrame from "./ConfigurationFrames/LoginPasswordFrame";
import ProgrammingFrame from "./ConfigurationFrames/ProgrammingFrame";
import AssistanceFrame from "./ConfigurationFrames/AssistanceFrame";
import ConfigureFrame from "./ConfigurationFrames/ConfigureFrame";
import SystemFrame from "./ConfigurationFrames/SystemFrame";
import DeviceZoneFrame from "./ConfigurationFrames/DeviceZoneFrame";
import ClockFrame from "./ConfigurationFrames/ClockFrame";
import GeneralFrame from "./ConfigurationFrames/GeneralFrame";
import AdditionalCardsFrame from "./ConfigurationFrames/AdditionalCardsFrame";
import DetectorsFrame from "./ConfigurationFrames/DetectorsFrame";
import ModulesFrame from "./ConfigurationFrames/ModulesFrame";
import ZonesFrame from "./ConfigurationFrames/ZonesFrame";
import LogicFunctionsFrame from "./ConfigurationFrames/LogicFunctionsFrame";
import OutputZonesFrame from "./ConfigurationFrames/OutputZonesFrame";
import LanguageFrame from "./ConfigurationFrames/LanguageFrame";
import LoopTypeFrame from "./ConfigurationFrames/LoopTypeFrame";
import VariousFrame from "./ConfigurationFrames/VariousFrame";
import SupervisionFrame from "./ConfigurationFrames/SupervisionFrame";
import BuzzerLedFrame from "./ConfigurationFrames/BuzzerLedFrame";
import PanelInfoFrame from "./ConfigurationFrames/PanelInfoFrame";
import LoopExpansionFrame from "./ConfigurationFrames/LoopExpansionFrame";
import VTNETFrame from "./ConfigurationFrames/VTNETFrame";
import ValuesFactoryFrame from "./ConfigurationFrames/ValuesFactoryFrame";
import PasswordsFrame from "./ConfigurationFrames/PasswordsFrame";
import ModifyPasswordFrame from "./ConfigurationFrames/ModifyPasswordFrame";
import ConfirmPasswordFrame from "./ConfigurationFrames/ConfirmPasswordFrame";
import SummertimeFrame from "./ConfigurationFrames/SummertimeFrame";
import ManualSummertimeFrame from "./ConfigurationFrames/ManualSummertimeFrame";
import HolidaysFrame from "./ConfigurationFrames/HolidaysFrame";
import TimeSlotFrame from "./ConfigurationFrames/TimeSlotFrame";
import WeeklyTrendsFrame from "./ConfigurationFrames/WeeklyTrendsFrame";
import DevicesContent from "./DevicesContent";
import AddWeeklyTrendsFrame from "./ConfigurationFrames/AddWeeklyTrendsFrame";
import ModifyWeeklyTrendsFrame from "./ConfigurationFrames/ModifyWeeklyTrends";
import DeleteWeeklyTrendsFrame from "./ConfigurationFrames/DeleteWeeklyTrendsFrame";
import UpdateAddWeeklyTrendsFrame from "./ConfigurationFrames/UpdateAddWeeklyTrendsFrame";
import UpdateModifyWeeklyTrendsFrame from "./ConfigurationFrames/UpdateModifyWeeklyTrendsFrame";
import AddTimeSlotFrame from "./ConfigurationFrames/AddTimeSlotFrame";
import ModifyTimeSlotFrame from "./ConfigurationFrames/ModifyTimeSlotFrame";
import DeleteTimeSlotFrame from "./ConfigurationFrames/DeleteTimeSlotFrame";
import UpdateAddTimeSlotFrame from "./ConfigurationFrames/UpdateAddTimeSlotFrame";
import UpdateModifyTimeSlotFrame from "./ConfigurationFrames/UpdateModifyTimeSlotFrame";
import UpdateModifyWeeklyTrendsShowTimeSlotFrame from "./ConfigurationFrames/UpdateModifyWeeklyTrendsShowTimeSlotFrame";
import UpdateAddWeeklyTrendsShowTimeSlotFrame from "./ConfigurationFrames/UpdateAddWeeklyTrendsShowTimeSlotFrame";

const ConfigurationContent = ({ project, setSelectedSubNavItem, updatePanels, panelVersion }) => {
  const [currentFrame, setCurrentFrame] = useState("main");
  const [selectedTimeSlotIndex, setSelectedTimeSlotIndex] = useState(null);
  const [selectedWeeklyTrendIndex, setSelectedWeeklyTrendIndex] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [isFromShowTimeSlot, setIsFromShowTimeSlot] = useState(false);
  const [tempTimeSlotsIndex, setTempTimeSlotsIndex] = useState(Array(8).fill(0));

  const handleFrameChange = (newFrame) => {
    if ((newFrame === "updateModifyWeeklyTrends" && currentFrame !== "updateModifyWeeklyTrendsShowTimeSlot") || (newFrame === "updateAddWeeklyTrends" && currentFrame !== "updateAddWeeklyTrendsShowTimeSlot")) {
      setIsFromShowTimeSlot(false); // Reset if NOT coming from showTimeSlot
      setSelectedDay(null);
    }
    setCurrentFrame(newFrame);
  };

  const frameComponents = {
    main: <MainFrame setCurrentFrame={setCurrentFrame} />,
    loginpassword: <LoginPasswordFrame setCurrentFrame={setCurrentFrame} project={project} />,
    programming: <ProgrammingFrame setCurrentFrame={setCurrentFrame} />,
    assistance: <AssistanceFrame setCurrentFrame={setCurrentFrame} project={project} panelVersion={panelVersion} />,
    configure: <ConfigureFrame setCurrentFrame={setCurrentFrame} panelVersion={panelVersion} />,
    system: <SystemFrame setCurrentFrame={setCurrentFrame} />,
    deviceZone: <DeviceZoneFrame setCurrentFrame={setCurrentFrame} project={project} panelVersion={panelVersion} />,
    clock: <ClockFrame setCurrentFrame={setCurrentFrame} />,
    general: <GeneralFrame setCurrentFrame={setCurrentFrame} />,
    additionalCards: <AdditionalCardsFrame setCurrentFrame={setCurrentFrame} />,
    detectors: <DetectorsFrame setCurrentFrame={setCurrentFrame} setSelectedSubNavItem={setSelectedSubNavItem} />,
    modules: <ModulesFrame setCurrentFrame={setCurrentFrame} setSelectedSubNavItem={setSelectedSubNavItem} />,
    zones: <ZonesFrame setCurrentFrame={setCurrentFrame} setSelectedSubNavItem={setSelectedSubNavItem} />,
    logicFunctions: <LogicFunctionsFrame setCurrentFrame={setCurrentFrame} setSelectedSubNavItem={setSelectedSubNavItem} />,
    outputZones: <OutputZonesFrame setCurrentFrame={setCurrentFrame} setSelectedSubNavItem={setSelectedSubNavItem} />,
    language: <LanguageFrame setCurrentFrame={setCurrentFrame} project={project} />,
    loopType: <LoopTypeFrame setCurrentFrame={setCurrentFrame} project={project} />,
    various: <VariousFrame setCurrentFrame={setCurrentFrame} project={project} panelVersion={panelVersion} />,
    supervision: <SupervisionFrame setCurrentFrame={setCurrentFrame} project={project} />,
    buzzerLed: <BuzzerLedFrame setCurrentFrame={setCurrentFrame} project={project} />,
    panelInfo: <PanelInfoFrame setCurrentFrame={setCurrentFrame} project={project} updatePanels={updatePanels} />,
    loopExpansion: <LoopExpansionFrame setCurrentFrame={setCurrentFrame} project={project} />,
    vtNET: <VTNETFrame setCurrentFrame={setCurrentFrame} project={project} />,
    valuesFactory: <ValuesFactoryFrame setCurrentFrame={setCurrentFrame} project={project} updatePanels={updatePanels} />,
    passwords: <PasswordsFrame setCurrentFrame={setCurrentFrame} project={project} />,
    modifyPassword: <ModifyPasswordFrame setCurrentFrame={setCurrentFrame} project={project} />,
    confirmPassword: <ConfirmPasswordFrame setCurrentFrame={setCurrentFrame} project={project} />,
    summertime: <SummertimeFrame setCurrentFrame={setCurrentFrame} project={project} />,
    manualSummertime: <ManualSummertimeFrame setCurrentFrame={setCurrentFrame} project={project} />,
    holidays: <HolidaysFrame setCurrentFrame={setCurrentFrame} project={project} />,
    timeSlot: <TimeSlotFrame setCurrentFrame={setCurrentFrame} project={project} />,
    weeklyTrends: <WeeklyTrendsFrame setCurrentFrame={setCurrentFrame} project={project} />,
    devices: <DevicesContent project={project} />,
    addWeeklyTrends: <AddWeeklyTrendsFrame setCurrentFrame={handleFrameChange} setSelectedWeeklyTrendIndex={setSelectedWeeklyTrendIndex} project={project} />,
    modifyWeeklyTrends: <ModifyWeeklyTrendsFrame setCurrentFrame={handleFrameChange} setSelectedWeeklyTrendIndex={setSelectedWeeklyTrendIndex} project={project} />,
    deleteWeeklyTrends: <DeleteWeeklyTrendsFrame setCurrentFrame={setCurrentFrame} project={project} />,
    updateAddWeeklyTrends: <UpdateAddWeeklyTrendsFrame setCurrentFrame={handleFrameChange}
      project={project}
      selectedWeeklyTrendIndex={selectedWeeklyTrendIndex}
      selectedTimeSlotIndex={selectedTimeSlotIndex}
      setSelectedTimeSlotIndex={setSelectedTimeSlotIndex}
      selectedDay={selectedDay}
      setSelectedDay={setSelectedDay}
      isFromShowTimeSlot={isFromShowTimeSlot}
      tempTimeSlotsIndex={tempTimeSlotsIndex}
      setTempTimeSlotsIndex={setTempTimeSlotsIndex}
    />,
    updateModifyWeeklyTrends: <UpdateModifyWeeklyTrendsFrame
      setCurrentFrame={handleFrameChange}
      project={project}
      selectedWeeklyTrendIndex={selectedWeeklyTrendIndex}
      selectedTimeSlotIndex={selectedTimeSlotIndex}
      setSelectedTimeSlotIndex={setSelectedTimeSlotIndex}
      selectedDay={selectedDay}
      setSelectedDay={setSelectedDay}
      isFromShowTimeSlot={isFromShowTimeSlot}
      tempTimeSlotsIndex={tempTimeSlotsIndex}
      setTempTimeSlotsIndex={setTempTimeSlotsIndex}
    />,
    addTimeSlot: <AddTimeSlotFrame setCurrentFrame={setCurrentFrame} setSelectedTimeSlotIndex={setSelectedTimeSlotIndex} project={project} />,
    modifyTimeSlot: <ModifyTimeSlotFrame setCurrentFrame={setCurrentFrame} setSelectedTimeSlotIndex={setSelectedTimeSlotIndex} project={project} />,
    deleteTimeSlot: <DeleteTimeSlotFrame setCurrentFrame={setCurrentFrame} project={project} />,
    updateAddTimeSlot: <UpdateAddTimeSlotFrame setCurrentFrame={setCurrentFrame} project={project} selectedTimeSlotIndex={selectedTimeSlotIndex} />,
    updateModifyTimeSlot: <UpdateModifyTimeSlotFrame setCurrentFrame={setCurrentFrame} project={project} selectedTimeSlotIndex={selectedTimeSlotIndex} />,
    updateModifyWeeklyTrendsShowTimeSlot: <UpdateModifyWeeklyTrendsShowTimeSlotFrame
      setCurrentFrame={handleFrameChange}
      project={project}
      selectedTimeSlotIndex={selectedTimeSlotIndex}
      setSelectedTimeSlotIndex={setSelectedTimeSlotIndex}
      selectedDay={selectedDay}
      setIsFromShowTimeSlot={setIsFromShowTimeSlot}
      tempTimeSlotsIndex={tempTimeSlotsIndex}
      setTempTimeSlotsIndex={setTempTimeSlotsIndex}
    />,
    updateAddWeeklyTrendsShowTimeSlot: <UpdateAddWeeklyTrendsShowTimeSlotFrame
      setCurrentFrame={handleFrameChange}
      project={project}
      selectedTimeSlotIndex={selectedTimeSlotIndex}
      setSelectedTimeSlotIndex={setSelectedTimeSlotIndex}
      selectedDay={selectedDay}
      setIsFromShowTimeSlot={setIsFromShowTimeSlot}
      tempTimeSlotsIndex={tempTimeSlotsIndex}
      setTempTimeSlotsIndex={setTempTimeSlotsIndex}
    />,
  };

  return (
    <div className="frame-container">
      <div
        className="frame"
        style={{
          width: "960px",
          height: "540px",
          border: "1px solid black",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // backgroundColor: "#000"
        }}
      >
        {frameComponents[currentFrame]}
      </div>
    </div>
  );
};

export default ConfigurationContent;
